// @flow

import * as React from 'react';
import { useOnVisible } from '@ta/common.is-visible';
import { trackEventAJAXOnPageOnce, type TrackingEventAJAXProps } from './tracking';

/**
 *
 * @param params The tracking parameters. See definition for more details
 * @param rootMargin See Intersection Observer API: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * @param threshold
 * @returns {*} A ref to set on an HTML element. If the element is visible, then a tracking event will fire.
 */
const useGARecordImpression = <T>(
  params: TrackingEventAJAXProps,
  rootMargin?: number | string = 0,
  threshold?: number = 1,
): { current: T | null } => {
  const { current: onVisible } = React.useRef(() => {
    // use trackEventAJAXOnPageOnce instead of trackEventAJAX to account for cases where the parent component gets unmounted
    trackEventAJAXOnPageOnce(params);
  });
  return useOnVisible<T>(onVisible, rootMargin, threshold);
};

export default useGARecordImpression;
